import "../pages.scss"
import { ColoresState } from '../../context/colores/ColoresState';
import Datatable from "./coloresTable/Datatable"

const ColoresPage = () => {
  return (
    <>
      <ColoresState>
        <Datatable />
      </ColoresState>
    </>
  )
}

export default ColoresPage